import React from "react";
// Headings
import date from "../images/headings/date.svg";
import location from "../images/headings/Brooklyn.svg";
import merch from "../images/headings/shamir.svg";
import artist1 from "../images/headings/straingeBeast.svg";
import plant from "../images/headings/plant.svg";
import tacos from "../images/headings/freeTacos.svg";
import totes from "../images/headings/freeTotes.svg";

const HeroHeadings = ({ toggleModal, setModalContent, toggleScroll }) => {
  const handleClick = (e, content) => {
    e.preventDefault();
    toggleModal(true);
    toggleScroll(`hidden`);
    setModalContent(content);
  };
  return (
    <>
      <img
        className="heading heading--date"
        src={date}
        alt="June 25, 2021, 4-8pm"
      />
      <img
        className="heading heading--location"
        src={location}
        alt="Brooklyn, New York"
      />
      <button
        className="heading heading--merch heading--modal-trigger"
        onClick={(e) => handleClick(e, "shamir")}
      >
        <img src={merch} alt="Merch signing with Shamir" />
        <span>Learn more</span>
      </button>
      <button
        className="heading heading--artist1 heading--modal-trigger"
        onClick={(e) => handleClick(e, "straingeBeast")}
      >
        <img src={artist1} alt="Merch signing with Shamir" />
        <span>Learn more</span>
      </button>
      <img
        className="heading heading--plant"
        src={plant}
        alt="Your very own plant"
      />
      <img className="heading heading--tacos" src={tacos} alt="Free Tacos" />
      <img className="heading heading--totes" src={totes} alt="Free Totes" />
      <p className="heading heading--supplies">
        <sup>*</sup>While supplies last
      </p>
    </>
  );
};

export default HeroHeadings;
